import React from 'react';
import { Button } from '../../../components/ui/Button';

/**
 * Centered "no data yet" panel used by every Hardware table's emptyMessage.
 * Renders:
 *   - tinted-square icon
 *   - title ("No devices added yet")
 *   - subtitle ("Add your first device to get started")
 *   - optional CTA button (label + onClick)
 *
 * Style classes live in styles/pp-overrides.css.
 */
export default function EmptyState({
  icon = 'pi-inbox',
  title,
  description,
  cta,           // { label, onClick, icon }
}) {
  return (
    <div className="pp-empty">
      <span className="pp-empty-icon">
        <i className={`pi ${icon}`} />
      </span>
      {title && <p className="pp-empty-title">{title}</p>}
      {description && <p className="pp-empty-desc">{description}</p>}
      {cta && (
        <Button
          icon={cta.icon ?? 'pi pi-plus'}
          label={cta.label}
          onClick={cta.onClick}
        />
      )}
    </div>
  );
}
